import EN from './en.png'
import ID from './id.png'
import TH from './th.png'
import VI from './vi.png'
import store from '@/store'
import { computed } from 'vue'

// 繁中由 sectionTitles 提供完整设计稿标题，其他语言双端共用以下艺术字。
const langToImgMap = {
  en: EN,
  sg: EN,
  my: EN,
  ph: EN,
  id: ID,
  th: TH,
  vi: VI,
}

export default computed(() => langToImgMap[store.state.locale])
